import React, { useEffect } from "react";
import MasterComponent from "../../../components/Forms";
import { MasterConfigs } from "../../../interfaces/entity";
import CommonView, { CommonViewProps } from "../../../components/CommonView/CommonView";
import { Space, Typography } from "antd";
import { useDispatch } from "react-redux";
const { Title, Text } = Typography;

const AssetsCategory = () => {
    const [selectedId, setSelectedId] = React.useState(null);
    const [load, setLoad] = React.useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedId) {
            dispatch({
                type: 'REFRESH_TABLE',
                refreshTable: true,
                query: { assetsCategory: selectedId }
            })
        }
    }, [selectedId]);

    const config: MasterConfigs = {
        api: () => '/assets-category',
        title: 'Assets Categories & Types',
        modalTitle: (action) => `${action} ${config.title}`,
        getColumns: () => [],
        onRefresh: () => setLoad(true),
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }],
    }

    const assetsCategory: MasterConfigs = {
        api: () => `/asstes-types`,
        title: 'Assets Types',
        apiParams: { assetsCategory: selectedId },
        modalTitle: (action) => `${action} ${assetsCategory.title}`,
        actions: [{ actionType: 'Add', name: 'Add' }],
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Short Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: 600,
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Short Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter short code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            }
        ]
    }


    const commonViewProps: CommonViewProps = {
        config: config,
        listProps: { reload: load, onLoaded: () => setLoad(false) },
        componentConfig: {
            title: 'Assets Categories & Types',
            subTitle: 'Managing Asset Categories and Types in an Asset Management System',
            cardTitle: 'Assets Categories',
            buttonName: 'Add Asset Category',
            emptyDescription: 'No Category found',
            customHeading: (record) => <Space direction="vertical" className="w-full">
                <Title level={5} className="!mb-[0px]" style={{ lineHeight: 1 }}>{record.name}</Title>
                <Text type="secondary">{record?.description}</Text>
            </Space>,
            renderComponent: (record) => <MasterComponent config={assetsCategory} />,
            renderListItem: (item) => {
                return <>
                    <Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>{item.name}</Title>
                    <Text type="secondary">{item?.code}</Text>
                </>
            },
            selectedItemId: (id) => setSelectedId(id),
        }
    }

    return <CommonView {...commonViewProps} />
}

export default AssetsCategory; 